export enum ISSUING_TRANSACTION_STATUS {
  PENDING = 'PENDING',
  VALIDATED = 'VALIDATED',
  REVERSED = 'REVERSED',
}

export type IssuingTransactionStatus =
  (typeof ISSUING_TRANSACTION_STATUS)[keyof typeof ISSUING_TRANSACTION_STATUS];
